export var defaultMonthOptions = {
    width: 7,
    height: 6
};
//# sourceMappingURL=_defaults.js.map


//////////////////
// WEBPACK FOOTER
// /app/SPA/~/ngx-bootstrap/datepicker/reducer/_defaults.js
// module id = ../../../../ngx-bootstrap/datepicker/reducer/_defaults.js
// module chunks = 4